import { apiService } from '../../shared/services/apiService';
import { TaxRateInfo } from '../interfaces/tax';

export const challengeTaxService = {
  async getChallengeTaxRate(entityId: number) {
    const resp = await apiService.get<TaxRateInfo>(
      `/api/entity/${entityId}/challenge/tax-rate`,
    );

    return resp.data;
  },

  async createChallengeTaxRate(entityId: number, taxRatePercent: number) {
    const resp = await apiService.post<TaxRateInfo>(
      `/api/entity/${entityId}/challenge/tax-rate`,
      { taxRatePercent },
    );

    return resp.data;
  },

  async updateChallengeTaxRate(
    entityId: number,
    taxRateId: number,
    taxRatePercent: number,
  ) {
    const resp = await apiService.put<TaxRateInfo>(
      `/api/entity/${entityId}/challenge/tax-rate/${taxRateId}`,
      { taxRatePercent },
    );

    return resp.data;
  },
};
